<template>
  <div class="department-search-item">
    <div
      :class="{ 'department-name': true, clamp: !keyword }"
      v-html="departmentBatchHighLightWord({ key: 'name', keyword, department: value })"
    />
    <div
      :class="{ 'department-code': true, clamp: !keyword }"
      v-html="departmentBatchHighLightWord({ key: 'custDeptNumber', keyword, department: value })"
    />
    <div
      :class="{ 'department-path': true, clamp: !keyword }"
      v-html="departmentBatchHighLightWord({ key: 'path', keyword, department: value })"
    ></div>
  </div>
</template>

<script type="text/ecmascript-6">

import {departmentBatchHighLightWord} from 'src/components/base-ui-v3/tree-select/util/department-core.js';

/**
 * 部门列表的item部分Ui
 */
export default {
  name:'department-search-item',
  props:{
    value:{
      type:Object,
    },
    keyword:{
      type:String,
      defalut:''
    }
  },
  data() {
    return {
    };
  },
  computed:{
    showMine(){
      return this.userInfo?.departmentOID === this.value.departmentOID;
    }
  },
  methods:{
    departmentBatchHighLightWord(props){
      let showText=departmentBatchHighLightWord(props);
      if(props.key==='path'){
        return (showText ||'').includes('|') ? showText : null;
      }
      return showText;
    }
  }

};
</script>

<style lang="scss" scoped>
.department-search-item {
  height: 100%;
  .department-name {
    word-break: break-word;
    color: #252629;
    font-weight: 400;
    font-size: px(28);
    &.clamp {
      @include text-line(3);
    }
    &-mine {
      //box-sizing: border-box;
      background: #dde2e5;
      color: #495c6d;
      padding: px(2) px(8);
      line-height: px(32);
      font-weight: 400;
      border-radius: px(2);
      font-size: px(20);
    }
  }
  .department-code {
    color: #71757e;
    font-weight: 400;
    font-size: px(24);
  }
}
</style>
